// src/components/Location.js
import React from 'react';
import '../styles/Location.css';
import { FaMapMarkerAlt } from 'react-icons/fa';

const Location = () => {
  return (
    <section className="location-container">
      <div className="location-header">
        <FaMapMarkerAlt className="location-icon" />
        <h2>Nossa Base</h2>
        <p>Rua José Samogim, 3-33 - Jardim Prudência, Bauru - SP</p>
      </div>
      
      <div className="map-responsive">
        <iframe 
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3690.494538265604!2d-49.109098599999996!3d-22.3185908!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94bf67b0760cb32d%3A0x2cc124e169ac8cac!2sTrVictor%20Guincho%20e%20transportes!5e0!3m2!1spt-BR!2sbr!4v1731975996302!5m2!1spt-BR!2sbr" 
          width="600" 
          height="450" 
          style={{ border: 0 }} 
          allowFullScreen="" 
          loading="lazy" 
          referrerPolicy="no-referrer-when-downgrade"
          title="Localização TR Victor Guincho"
        ></iframe>
      </div>
    </section>
  );
}

export default Location;